import { Outlet } from "react-router";
import Navbar from "./Navbar";
import Footer from "./Footer";

function Layout() {
  return (
    <>
      <Navbar />
      <div className="max-w-[560px] mx-auto pt-[56px] lg:max-w-4xl xl:max-w-[90em]">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}

export default Layout;
